export default __webpack_public_path__ + "static/media/img-cyln-card.e04a1ce9.jpg";